'use strict';

import React, { Component, Fragment } from 'react';
import uniqid from 'uniqid';
import moment from 'moment';
import striptags from 'striptags';
import Button from '@material-ui/core/Button';
import { PiTextAlignLeftFill } from 'react-icons/pi';
import { FaMapLocationDot } from 'react-icons/fa6';
import { PiSquaresFourLight } from 'react-icons/pi';
import { etablishment as etablishment_icons } from 'Components/IconsConfigs';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import SpacesBlock from 'Components/Blocks/SpacesBlock';
import PhotoIcon from 'Icons/PhotoIcon';
import SideWidget from 'Components/Front/SideWidget';
import Breadcrumb from 'Components/Front/Breadcrumb';
import EstablishmentMap from 'Components/Front/EstablishmentMap';
import NavigationTabs from 'Components/Front/NavigationTabs';
import Loader from 'Pure/Loader';
import Image from 'Pure/Image';
import EtablishmentIcon from 'Icons/BuildingIcon';
import PeopleIcon from 'Icons/People';
import PhoneIcon from 'Icons/Phone';
import myWOIcon from 'Icons/myWO';
import MapIcon from 'Icons/Map';
import truncate from 'Functions/truncate';
import bemit from 'Functions/bemit';
import { updateSessionStorage } from 'Functions/SessionStorage/frontPage';
import { getSpacedPhoneNumber, num } from 'Shared/utilities';
import { coworking_place_types, etablishment_equipments } from 'Shared/options';
import { action, URL } from 'Shared/Routes';
const app = window.app;
const qwest = window.qwest;
const etablishment_bemit = ['list'];
const MAX_HEIGHT = 200;
const SECTIONS = {
  map: 'map',
  spaces: 'info',
  description: 'description',
  photos: 'photos',
  intro: 'intro'
};
const TABS_CONFIG = [{
  label: 'Informations',
  id: SECTIONS.intro,
  Icon: PiSquaresFourLight
}, {
  label: 'Espaces',
  id: SECTIONS.spaces,
  Icon: myWOIcon,
  icon_suffix: 'myWO'
}, {
  label: 'Présentation',
  id: SECTIONS.description,
  Icon: PiTextAlignLeftFill
}, {
  label: 'Galerie',
  id: SECTIONS.photos,
  Icon: PhotoIcon
}, {
  label: 'Localisation',
  id: SECTIONS.map,
  Icon: FaMapLocationDot
}];
export default class FrontEtablishmentPageContent extends Component {
  state = function () {
    const state = {
      loading: true,
      pathname: this.props.pathname,
      desc_expanded: false,
      space_type_filter: this.props.get_params.type || 'all',
      description_style: {
        maxHeight: MAX_HEIGHT
      },
      TABS_CONFIG: TABS_CONFIG
    };
    return state;
  }.bind(this)();
  desc_ref = React.createRef();
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'window.resize',
      cb: component.handleResize
    });
    app.push({
      event: 'UpdateSideWidgetDate',
      cb: component.updateDate
    });
    component.setState({
      pathname: document.location.pathname
    });
    component.fetchData();
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'window.resize',
      cb: component.handleResize
    });
    app.delete({
      event: 'UpdateSideWidgetDate',
      cb: component.updateDate
    });
  }
  handleResize = ({
    source
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.desc_expanded === true) return;
    if (state.description?.__html?.length > 0 === false) return;
    if (!component.desc_ref?.current) return;
    const description = component.desc_ref.current.querySelector('.js-description');
    if (!description) return;
    const height = description.getBoundingClientRect().height;
    if (height > 0 === false) {
      return window.requestAnimationFrame(function () {
        component.handleResize({
          source: 'handleResize'
        });
      });
    }
    if (height > MAX_HEIGHT && state.desc_expanded !== true) {
      component.setState({
        more_desc_btn: true
      });
    }
  };
  fetchData = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getAllFrontEtablishments'), {
      slug: document.location.pathname.slice(document.location.pathname.lastIndexOf('/') + 1),
      striptags: false
    }).then(function (xhr, response) {
      const etablishment = response.data || {};
      etablishment.address = etablishment.address || {};
      if (typeof props.onFetch === 'function') {
        props.onFetch({
          establishment: etablishment
        });
      }
      let address = [etablishment.address.line_1 || '', ' ', etablishment.address.line_2 || '', ', ', etablishment.address.postal_code || '', ' ', etablishment.address.city || ''].join('');
      let meta_description = truncate(striptags(etablishment.description), 160);
      if (meta_description.endsWith('...')) {
        meta_description = meta_description.slice(0, -3);
      }
      const metas = {
        title: etablishment.name,
        description: meta_description
      };
      let gallery_imgs;
      if (etablishment.images?.length > 1) {
        gallery_imgs = etablishment.images.map(function (image) {
          let data = {
            alt: image.alt || image.title || etablishment.name,
            src: image.url,
            id: uniqid()
          };
          return data;
        });
        Object.assign(metas, {
          og_image: gallery_imgs[0].src,
          og_image_alt: gallery_imgs[0].alt
        });
      }
      app.emit({
        event: 'setMetas',
        data: metas
      });
      const description = (etablishment.description || '').split('<p><br></p>').join('');
      component.setState({
        id: etablishment.id,
        city: etablishment.address.city,
        title: etablishment.name,
        hotel_name: etablishment.address.hotel_name,
        address: address,
        phone_number: etablishment.phone_number,
        service: etablishment.service || [],
        description: {
          __html: description
        },
        images: etablishment.images,
        background: etablishment.images?.[0]?.url || undefined,
        spaces_count: response.spaces_count,
        TABS_CONFIG: TABS_CONFIG.map(function (opt) {
          if (opt.id === SECTIONS.spaces && response.spaces_count) {
            const new_opt = {
              ...opt,
              label: response.spaces_count + ' espace' + (response.spaces_count > 1 ? 's' : '')
            };
            return new_opt;
          }
          return opt;
        }),
        gallery_imgs: gallery_imgs,
        __spaces_types: etablishment.__spaces_types || [],
        __spaces_max_bookable: etablishment.__spaces_max_bookable,
        loading: false,
        breadcrumb: [{
          name: 'home',
          url: URL('HomePage'),
          label: 'Accueil'
        }, {
          name: 'current-page',
          label: etablishment.name,
          url: URL('FrontEtablishmentPage').replace(':slug', etablishment.slug)
        }]
      });
      app.emit({
        event: 'TCPageView',
        source: 'FrontEtablishmentPage',
        data: {
          page: etablishment.name || 'Etablissement ',
          etablissement: etablishment.name || 'Etablissement',
          ville_reservation: etablishment.address?.city
        }
      });
      window.requestAnimationFrame(function () {
        component.handleResize({
          source: 'fetchData'
        });
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  toggleDesc = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      desc_expanded: true
    });
  };
  collapseDesc = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      desc_expanded: false
    });
  };
  handleSpacesFetched = ({
    spaces = [],
    spaces_max_bookable,
    count
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      spaces_count: count,
      widget_max_bookable: num(spaces_max_bookable, 0)
    });
  };
  updateDate = ({
    source
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const date = window.localStorage.getItem('widget-date');
    updateSessionStorage({
      pathname: props.pathname,
      date
    });
  };
  saveWidgetData = ({
    type
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    const match = coworking_place_types.find(opt => opt.value === type || opt.new_value === type);
    const new_type = match ? match.new_value : 'all';
    updateSessionStorage({
      pathname: props.pathname,
      type: new_type
    });
    component.setState({
      space_type_filter: new_type
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-transparent']
    }) : undefined;
    const services = etablishment_icons.filter(infos => (state.service || []).includes(infos.value)).map(function (infos) {
      const Icon = infos.icon;
      const equipment = etablishment_equipments.find(opt => (opt.value || opt.label) === infos.value);
      const output = /*#__PURE__*/React.createElement("div", {
        className: "c-services-icons__item",
        key: infos.value
      }, /*#__PURE__*/React.createElement(Icon, {
        className: "c-services-icons__svg"
      }), /*#__PURE__*/React.createElement("span", {
        className: "c-services-icons__label"
      }, equipment?.label || infos.label || infos.value));
      return output;
    });
    const description = state.description?.__html ? /*#__PURE__*/React.createElement("div", {
      className: "front-etablishment-description",
      ref: component.desc_ref
    }, /*#__PURE__*/React.createElement("div", {
      className: "front-etablishment-description__wrapper",
      style: state.desc_expanded === 42 ? state.description_style : undefined
    }, /*#__PURE__*/React.createElement("div", {
      className: "front-etablishment-description__content\r js-description",
      dangerouslySetInnerHTML: state.description
    })), state.more_desc_btn === true && state.desc_expanded === 42 ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "front-more-desc-effect"
    }), /*#__PURE__*/React.createElement(Button, {
      className: "front-more-desc",
      onClick: component.toggleDesc
    }, "En savoir plus")) : undefined, state.more_desc_btn === true && state.desc_expanded === 42 ? /*#__PURE__*/React.createElement(Button, {
      className: "front-more-desc",
      onClick: component.collapseDesc
    }, "Voir moins") : undefined) : undefined;
    const texts = /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__slider-texts"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "c-front-page-intro__title"
    }, state.title), /*#__PURE__*/React.createElement("address", {
      className: "c-front-page-intro__address"
    }, /*#__PURE__*/React.createElement(MapIcon, {
      className: "c-front-page-intro__address-icon"
    }), state.address), /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__address"
    }, /*#__PURE__*/React.createElement(EtablishmentIcon, {
      className: "c-front-page-intro__address-icon"
    }), state.hotel_name));
    const phone_number = state.phone_number ? /*#__PURE__*/React.createElement("div", {
      className: "front-tiles__element"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "front-tiles__title"
    }, "Contact"), /*#__PURE__*/React.createElement("a", {
      onClick: onPhoneClick,
      className: bemit('c-infos-label', ['phone-number']),
      href: 'tel:' + state.phone_number.split(' ').join('')
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-infos-label__title",
      "data-mobile-label": "Appeler"
    }, /*#__PURE__*/React.createElement(PhoneIcon, {
      className: "c-infos-label__icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "c-infos-label__title-txt"
    }, "T\xE9l\xE9phone")), /*#__PURE__*/React.createElement("span", {
      className: "c-infos-label__txt"
    }, getSpacedPhoneNumber(state.phone_number)))) : undefined;
    const types_list = (state.__spaces_types || []).map(function (value) {
      const opt = coworking_place_types.find(opt => opt.value === value || opt.new_value === value);
      const output = /*#__PURE__*/React.createElement("li", {
        className: "front-tiles__label",
        key: value
      }, opt?.front_short_label || opt?.front_label, state.__spaces_max_bookable?.[value] ? /*#__PURE__*/React.createElement(PeopleIcon, {
        className: "front-tiles__label-peoples"
      }) : undefined, state.__spaces_max_bookable?.[value]);
      return output;
    });
    let spaces_title = state.spaces_count || 'Les';
    spaces_title += ' espace' + (state.spaces_count > 1 ? 's' : '');
    if (state.space_type_filter && state.space_type_filter !== 'all') {
      const match = coworking_place_types.find(opt => [opt.value, opt.new_value].includes(state.space_type_filter));
      if (match) {
        spaces_title += ' ' + match.front_short_label.toLowerCase();
      }
    }
    spaces_title += ' dans votre myWO';
    const open_gallery_btn = /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['front']),
      onClick: props.openGalleryModal
    }, /*#__PURE__*/React.createElement(PhotoIcon, {
      className: "c-front-page-intro__address-icon"
    }), "Photos");
    const gallery_imgs = (state.gallery_imgs || []).slice(0, 4).map(function ({
      alt,
      src,
      id
    }, i) {
      const output = /*#__PURE__*/React.createElement(Button, {
        className: "c-gallery__element",
        key: id,
        onClick: e => component.openModal(e, i)
      }, /*#__PURE__*/React.createElement("img", {
        src: src,
        alt: alt,
        className: "c-gallery__img"
      }), /*#__PURE__*/React.createElement("span", {
        className: "u-readers-only"
      }, "Toute la galerie"));
      if (i === 1 || state.gallery_imgs.length < 2) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: id
        }, output, /*#__PURE__*/React.createElement("div", {
          className: "c-gallery__element is-gallery-element"
        }, open_gallery_btn));
      }
      return output;
    });
    const gallery_section = state.gallery_imgs?.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", {
      className: "o-separator"
    }), /*#__PURE__*/React.createElement("h2", {
      id: SECTIONS.photos,
      className: bemit('c-title', ['front-subtitle']) + ' u-margin-bottom-25'
    }, "Galerie"), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-gallery', ['establishment']) + (gallery_imgs.length < 3 ? ' u-margin-bottom-50' : '')
    }, gallery_imgs)) : undefined;
    let output = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: bemit('c-front-page-intro', ['etablishment'])
    }, /*#__PURE__*/React.createElement(Image, {
      className: "c-front-page-intro__bg",
      src: state.background,
      alt: 'Illustration ' + state.title
    }), texts, /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__filter"
    }), loader), /*#__PURE__*/React.createElement("div", {
      className: "page-container u-positioned"
    }, /*#__PURE__*/React.createElement(Breadcrumb, {
      links: state.breadcrumb
    }), state.id ? /*#__PURE__*/React.createElement(SideWidget, {
      etablishment: state.id,
      city: state.city,
      "from-props": true,
      date: props.get_params.date,
      type: state.space_type_filter,
      available_spaces_types: state.__spaces_types,
      spaces_max_bookable: state.__spaces_max_bookable,
      onApply: component.saveWidgetData,
      onDateChange: component.updateDate
    }) : undefined, /*#__PURE__*/React.createElement("div", {
      className: "widget-left-side"
    }, /*#__PURE__*/React.createElement(NavigationTabs, {
      config: state.TABS_CONFIG,
      "with-back-top": true,
      "hide-photos": state.gallery_imgs?.length > 0 === false
    }), /*#__PURE__*/React.createElement("div", {
      className: "o-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "front-tiles",
      id: SECTIONS.intro
    }, /*#__PURE__*/React.createElement("div", {
      className: "front-tiles__element"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "front-tiles__title"
    }, "Espaces propos\xE9s"), types_list?.length > 0 ? /*#__PURE__*/React.createElement("ul", {
      className: "front-tiles__list"
    }, types_list) : 'Aucun espace disponible.'), phone_number, /*#__PURE__*/React.createElement("div", {
      className: "front-tiles__element"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "front-tiles__title"
    }, "Services"), /*#__PURE__*/React.createElement("div", {
      className: bemit('c-services-icons', ['v2'])
    }, services))), /*#__PURE__*/React.createElement("hr", {
      className: "o-separator"
    }), /*#__PURE__*/React.createElement("h2", {
      className: bemit('c-title', ['front-subtitle']),
      id: SECTIONS.spaces
    }, spaces_title), /*#__PURE__*/React.createElement("hr", {
      className: "o-separator u-margin-bottom-20"
    })), state.id ? /*#__PURE__*/React.createElement(SpacesBlock, {
      "etablishment-id": state.id,
      "layout-type": "side",
      bemit: etablishment_bemit,
      "items-per-page": 40,
      title: false,
      onFetch: component.handleSpacesFetched,
      "use-widget": false,
      with_spaces_max_bookable: true,
      pagination: false,
      "use-session": true,
      pathname: props.pathname
    }) : undefined, /*#__PURE__*/React.createElement("hr", {
      className: "o-separator u-margin-top-10"
    }), /*#__PURE__*/React.createElement("div", {
      className: "o-content"
    }, /*#__PURE__*/React.createElement("h2", {
      className: bemit('c-title', ['front-subtitle']),
      id: SECTIONS.description
    }, "Pr\xE9sentation"), description, gallery_section, /*#__PURE__*/React.createElement("hr", {
      className: 'o-separator' + (gallery_section ? ' u-margin-top-50' : '')
    }), /*#__PURE__*/React.createElement("h2", {
      className: bemit('c-title', ['front-subtitle', 'gmap']),
      id: SECTIONS.map
    }, "Localisation"), state.id ? /*#__PURE__*/React.createElement(EstablishmentMap, {
      id: state.id,
      "from-url": true
    }) : undefined))));
    return output;
    function onPhoneClick(e) {
      e.persist();
      app.emit({
        event: 'TC_Click',
        source: 'EtablishmentPage',
        data: {
          e: e,
          action: 'contacter_etablissement'
        }
      });
    }
  }
}
